import {
  Box,
  Card,
  CardContent,
  Typography,
  Divider,
  Button,
  Stack,
  Chip,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ShareIcon from "@mui/icons-material/Share";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useRef } from "react";

export default function ReceiptCard() {
  const receiptRef = useRef();

  const handleSharePDF = async () => {
    const original = receiptRef.current;
    const clone = original.cloneNode(true);

    clone.style.height = "auto";
    clone.style.overflow = "visible";
    clone.style.position = "absolute";
    clone.style.left = "-9999px";

    document.body.appendChild(clone);

    const canvas = await html2canvas(clone, {
      scale: 2,
      backgroundColor: "#ffe14d",
      height: clone.scrollHeight,
      windowHeight: clone.scrollHeight,
    });

    document.body.removeChild(clone);

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    const imgHeight = (canvas.height * pdfWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, "PNG", 0, position, pdfWidth, imgHeight);
    heightLeft -= pdfHeight;

    while (heightLeft > 0) {
      position -= pdfHeight;
      pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, position, pdfWidth, imgHeight);
      heightLeft -= pdfHeight;
    }

    pdf.save("Daalchini_Receipt.pdf");
  };

  return (
    <Box sx={{ bgcolor: "#ffe14d", p: 2, borderRadius: 3 }}>
      <Box sx={{ textAlign: "right", mb: 1 }}>
        <Button
          size="small"
          variant="contained"
          startIcon={<ShareIcon />}
          onClick={handleSharePDF}
        >
          Share
        </Button>
      </Box>

      <Card
        ref={receiptRef}
        sx={{
          maxWidth: 380,
          height: 620,            // 👈 FIXED PREVIEW
          overflowY: "auto",      // 👈 SCROLLABLE
          mx: "auto",
          borderRadius: 3,
        }}
      >
        <CardContent>
          <Typography fontWeight={700}>
            Order_2B74E9982D904BE1
          </Typography>
          <Typography color="text.secondary" mb={2}>
            19/11/2025, 4:00:59 pm
          </Typography>

          <Timeline
            title="Refund Initiated"
            subtitle="Refund Reference Number: 173087"
            time="19/11/2025, 4:15:59 pm"
          />

          <Timeline
            title="Refund Successful"
            time="19/11/2025, 4:38:01 pm"
          />

          <Divider sx={{ my: 2 }} />

          <Section title="Refunded Amount: ₹ 54">
            <Info text="19/11/2025, 4:38:01 pm" />
            <Info text="Transaction ID: 173087" />
            <Info text="Refund Account: WALLET_LOYALTY" />
          </Section>

          <Divider sx={{ my: 2 }} />

          <Section title="Order: 1 Items">
            <Stack direction="row" justifyContent="space-between">
              <Typography>Veggie Upma (01)</Typography>
              <Typography>₹ 60</Typography>
            </Stack>
            <Chip
              label="Pending (1)"
              size="small"
              sx={{ bgcolor: "#fff3e0", color: "#ef6c00", mt: 1 }}
            />
          </Section>

          <Divider sx={{ my: 2 }} />

          <Section title="Paid Amount: ₹ 60">
            <Info text="19/11/2025, 4:00:59 pm" />
            <Info text="Transaction ID: 173087" />
            <Info text="Payment Method: wallet" />
          </Section>

          <Box textAlign="center" mt={3}>
            <Typography fontWeight={700}>Daalchini</Typography>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}

/* ---------- Helpers ---------- */

function Timeline({ title, subtitle, time }) {
  return (
    <Stack direction="row" spacing={2} mb={2}>
      <CheckCircleIcon color="success" />
      <Box>
        <Typography fontWeight={600}>{title}</Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary">
            {subtitle}
          </Typography>
        )}
        <Typography variant="caption" color="text.secondary">
          {time}
        </Typography>
      </Box>
    </Stack>
  );
}

function Section({ title, children }) {
  return (
    <Box mb={2}>
      <Typography fontWeight={600} mb={1}>
        {title}
      </Typography>
      {children}
    </Box>
  );
}

function Info({ text }) {
  return (
    <Typography variant="body2" color="text.secondary">
      {text}
    </Typography>
  );
}
